import React, { useState, useEffect } from 'react'
import Icon from 'components/Icon'

const NavItem = ({ sub, children }) => {
  return (
    <div className="hidden md:inline-block py-6 px-4 text-white hover:text-primary text-base hover:bg-white cursor-pointer z-50 transition duration-150 ease-in-out whitespace-nowrap">
      <span className="whitespace-nowrap">{children}</span>
      {sub && (
        <span className="pl-2">
          <Icon icon="angle-down" />
        </span>
      )}
    </div>
  )
}

export default NavItem
